import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getInventoryitemList } from 'components/inventoryitem/InventoryitemAPI';
import { setInventoryitemList, setInventoryitemDashboardInventoryitemList } from 'store/slice/ManufSlice';
import InventoryitemDashboard from 'components/inventoryitem/InventoryitemDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function InventoryitemPageImpl() {
    const dispatch = useDispatch();
    const { inventoryitemList} = useSelector((state)=>state.manufslice);
    const {inventoryObj} = useSelector((state)=>state.manufslice.inventoryDashboard);
    
    const getInventoryitemListSuccess = (list) =>{dispatch(setInventoryitemList(list));}
    useEffect(() => {
       // dispatch(openDrawer(false));
        getInventoryitemList(()=>{}, getInventoryitemListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setInventoryitemDashboardInventoryitemList( inventoryitemList
            .filter((item) => item.productid == inventoryObj.productid)));
    },[ inventoryitemList])

    return (
        < InventoryitemDashboard />
    )

}